import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
/** @typedef {import('../types/pergunta').Pergunta} Pergunta */
/** @typedef {import('vue').Ref<Pergunta>} PerguntaRef */

const _loading = {
  pergunta: true,
  edit: false,
  planoAcao: true,
  acompanhamentos: true,
  enviandoResposta: false,
  enviandoPlanoAcao: false,
  enviandoAcompanhamento: false,
}
const _model = {
  fabricante: {
    id: window.context.user.fabricante_id,
    nome_fabricante: window.context.user.fabricante,
  },
}

export const usePerguntaStore = defineStore(
  'pergunta',
  () => {
    /** @type {PerguntaRef} */
    const pergunta = ref({})
    const respostas = ref({})
    const loading = ref({ ..._loading })
    const model = ref({ ..._model })
    const planoAcao = ref({})
    const acompanhamentos = ref({})
    const visualizacao = ref('column')
    const heightAlternativa = ref({})
    const modalPlanoAcaoRef = ref(null)
    const modalAcompanhamentoRef = ref(null)
    const modalEditarCamposRef = ref(null)

    const alternativas = computed(
      () => pergunta.value?.alternativa_set
    )

    function resetStore() {
      pergunta.value = {}
      respostas.value = {}
      loading.value = _loading
      model.value = _model
    }

    return {
      pergunta,
      alternativas,
      respostas,
      model,
      loading,
      planoAcao,
      visualizacao,
      acompanhamentos,
      heightAlternativa,
      resetStore,
      modalPlanoAcaoRef,
      modalAcompanhamentoRef,
      modalEditarCamposRef,
    }
  },
  {
    persist: {
      pick: ['visualizacao'],
    },
  }
)
